import { render } from "./ClinicList.vue?vue&type=template&id=78402c88&scoped=true&ts=true"
import script from "./ClinicList.vue?vue&type=script&lang=ts"
export * from "./ClinicList.vue?vue&type=script&lang=ts"

import "./ClinicList.vue?vue&type=style&index=0&id=78402c88&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78402c88"]])

export default __exports__